import { cn } from 'corso-admin-ui';
import { Fragment, ReactNode } from 'react';

export type Description = { term: string; details: ReactNode };

/**
 * Simple extension of the native `dl`, `dt`, and `dd` HTML elements.
 */
export default function DescriptionList({
  descriptions,
  layoutType = 'grid',
}: {
  /** Each `term` should be unique, as these are used as a `key` for each. */
  descriptions: Description[];
  /** Determines if the list should be displayed in 'grid' or 'list' layout. */
  layoutType?: 'grid' | 'list';
}) {
  return (
    <dl
      className={cn(
        'text-xs text-neutral-500',
        layoutType === 'grid'
          ? 'sm:grid-auto-cols grid sm:gap-x-3 sm:gap-y-3'
          : '',
      )}
    >
      {descriptions.map(({ term, details }) => (
        <Fragment key={term}>
          <dt
            className={cn(
              'font-semibold',
              layoutType === 'grid'
                ? 'col-span-2 sm:col-span-1 sm:col-start-1'
                : 'mb-1',
            )}
          >
            {term}
          </dt>
          <dd
            className={cn(
              'break-words',
              layoutType === 'grid'
                ? 'mb-2 sm:col-span-3 sm:col-start-2 sm:mb-0'
                : 'mb-3',
            )}
          >
            {details}
          </dd>
        </Fragment>
      ))}
    </dl>
  );
}
